'use client';

import * as React from 'react';

import {
    SidebarGroup,
    SidebarGroupContent,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    useSidebar,
} from '../ui/sidebar';
import { Link, useLocation } from 'react-router-dom';

export function NavSecondary({ items, ...props }) {
    const location = useLocation();
    const activePage = location.pathname;
    const { isMobile, setOpenMobile } = useSidebar();

    const handleMobileNavClose = () => {
        if (isMobile) {
            setOpenMobile(false);
        }
    };

    return (
        <SidebarGroup {...props}>
            <SidebarGroupContent>
                <SidebarMenu>
                    {items.map((item) => {
                        const isActive = item.url ? activePage === item.url : false;
                        const button = (
                            <SidebarMenuButton
                                className={
                                    isActive
                                        ? 'tw-min-w-8 tw-bg-gray-200 tw-duration-200 tw-ease-linear'
                                        : ''
                                }
                            >
                                <item.icon />
                                <span>{item.title}</span>
                            </SidebarMenuButton>
                        );
                        if (item.onClick) {
                            return (
                                <SidebarMenuItem key={item.title}>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            handleMobileNavClose();
                                            item.onClick();
                                        }}
                                        className="tw-w-full tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-0 tw-text-left"
                                    >
                                        {button}
                                    </button>
                                </SidebarMenuItem>
                            );
                        }
                        return (
                            <SidebarMenuItem key={item.title}>
                                <Link to={item.url} onClick={handleMobileNavClose}>
                                    {button}
                                </Link>
                            </SidebarMenuItem>
                        );
                    })}
                </SidebarMenu>
            </SidebarGroupContent>
        </SidebarGroup>
    );
}
